<template>
  <div class="order-step">
    <next-prev-menu
      :disabled="orderIncomplete"
      :previous="true"
      :title="confirmLabel"
      @next-step="submitOrder"
      @prev-step="$router.push({ name: prevStep })"
    ></next-prev-menu>

    <div
      class="card"
      v-if="!custom.hideDeliverOptions || !custom.hideInvoiceOptions"
    >
      <div class="confirm-card">
        <div class="main-error">
          <p class="error-text" v-if="orderIncomplete">
            Let op, uw order is nog niet compleet.
          </p>
          <h3 v-else>
            Controleer hieronder uw gegevens en klik op “{{ confirmLabel }}” om
            uw order af te ronden.
          </h3>
        </div>
        <phone-input
          v-if="phoneRequired"
          :model-value="order.phone"
          :placeholder="'Typ hier uw telefoonnummer'"
          :invalid="!order.phone"
          @update:model-value="setPhone"
        />
        <div class="card-2col">
          <deliver
            v-if="!custom.hideDeliverOptions"
            :order="order"
            :order-type="order.orderType"
            :print-store-only="printStoreOnly"
            :combi-order="combiOrder"
            :hide-errors="submitting"
            :hide-date="custom.hideDeliveryDates"
            @addError="addError"
            @removeError="removeError"
            @goTo="$router.push({ name: 'checkOutDeliver' })"
            :address-list="checkOutStore.deliveryAddressIncludedInFiles"
          ></deliver>
          <invoice
            v-if="!custom.hideInvoiceOptions"
            :order="order"
            :hide-errors="submitting"
            @addError="addError"
            @removeError="removeError"
            @goTo="$router.push({ name: 'checkOutInvoice' })"
          ></invoice>
        </div>
        <div class="instruction-holder">
          <button
            class="white-pill-s"
            v-if="order.instruction.length < 1 && !showInstruction"
            @click="showInstruction = true"
          >
            Heeft u nog opmerkingen bij deze opdracht? Klik dan hier.
          </button>
          <div v-else>
            <h3>Opmerkingen bij deze opdracht</h3>
            <textarea
              class="instruction-text grey-field"
              :value="order.instruction"
              @input="updateOrder('instruction', $event.target.value)"
              :placeholder="'Typ hier uw opmerking bij deze opdracht'"
            >
            </textarea>
          </div>
        </div>
      </div>
    </div>

    <div class="card file-list">
      <div class="title-container">
        <h3 v-if="custom.sapPortal && phoneRequired">
          Voer uw telefoonnummer in en controleer uw bestelling. Klik vervolgens
          op “{{ confirmLabel }}” om uw order af te ronden.
        </h3>
        <h3 v-else>Wat wij voor u gaan maken</h3>
      </div>

      <phone-input
        v-if="custom.sapPortal && phoneRequired"
        :model-value="order.phone"
        :invalid="!order.phone"
        @update:model-value="setPhone"
      />
      <ul class="print-file-list">
        <file
          v-for="file in fileList"
          :key="file.fileName"
          :file="file"
          :open="false"
          @no-product="$emit('go-to-step', 'step1')"
        ></file>

        <print-store-product
          v-for="(product, index) in printStoreProducts"
          :key="index"
          :product="product"
        ></print-store-product>
      </ul>

      <div class="totalprice">
        <span class="error-text" v-if="orderIncomplete"
          >Let op, uw order is nog niet compleet.</span
        >
        <span v-else-if="priceError && showPrice" class="error-text">
          <!--    Niet alle bestanden konden worden geanalyseerd, hierdoor kunnen wij
          geen juiste prijs tonen. -->
        </span>
        <span v-else-if="showPrice">
          Totaal:
          <span class="price">{{ orderPrice }}</span>
        </span>
      </div>
      <div class="confirm-footer">
        <legal class="legal"></legal>

        <next-button
          :label="confirmLabel"
          :disabled="orderIncomplete"
          @click="submitOrder"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Deliver from '@/components/confirm/Deliver.vue'
import Invoice from '@/components/confirm/Invoice.vue'
import Legal from '@/components/confirm/Legal.vue'
//import PrintstoreSidebarAd from '@/components/PrintstoreSidebarAd.vue'
import NextPrevMenu from '@/components/NextPrevMenu.vue'
import File from './File.vue'
import PrintStoreProduct from './PrintStoreProduct.vue'
import { sortBy } from 'lodash-es/collection'
import { EventBus } from '@/eventbus/EventBus'
import { useFileListStore } from '@/stores/FileList.store'
import { useCheckOutStore } from '@/features/checkOut/CheckOut.store'
import { mapStores } from 'pinia'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'
import NextButton from '@/components/NextButton.vue'
import PhoneInput from '@/components/ui/PhoneInput.vue'

export default {
  components: {
    Deliver,
    Invoice,
    Legal,
    //PrintstoreSidebarAd,
    NextPrevMenu,
    PrintStoreProduct,
    File,
    NextButton,
    PhoneInput
  },
  data() {
    return {
      showInstruction: false,
      submitting: false
    }
  },
  created() {
    if (this.phoneRequired && !this.order.phone && this.user.phone) {
      this.updateOrder('phone', this.user.phone)
    }
    if (this.custom.sapPortal && !this.order.phone) {
      this.addError('phone')
    } else {
      this.removeError('phone')
    }
    EventBus.on('orderSubmitting', this.onOrderSubmitting)
    EventBus.on('orderFailed', this.onOrderFailed)
  },
  unmounted() {
    EventBus.off('orderSubmitting', this.onOrderSubmitting)
    EventBus.off('orderFailed', this.onOrderFailed)
  },
  methods: {
    updateOrder(key, val) {
      this.checkOutStore.updateOrderDetails(key, val)
    },
    setPhone(val) {
      this.updateOrder('phone', val)
      if (val) {
        this.removeError('phone')
      } else {
        this.addError('phone')
      }
    },
    submitOrder() {
      EventBus.emit('submitOrder')
    },
    onOrderSubmitting() {
      this.submitting = true
    },
    onOrderFailed() {
      this.submitting = false
    },
    addError(val) {
      this.checkOutStore.addOrderError(val)
    },
    removeError(val) {
      this.checkOutStore.removeOrderError(val)
    }
  },
  computed: {
    custom() {
      return this.rootStore.theme.customFields
    },
    ...mapStores(useCheckOutStore, usePrintStoreStore, useFileListStore),
    printStoreProducts() {
      return sortBy(this.printStoreStore.orderDetails.cart, ['fileName'])
    },
    order() {
      return this.checkOutStore.orderDetails
    },
    confirmLabel() {
      return this.custom.sapPortal
        ? 'Bestelling verzenden'
        : 'Bestelling afronden'
    },
    prevStep() {
      if (
        !this.custom.hideDeliverOptions &&
        this.custom.hideInvoiceOptions &&
        !this.checkOutStore.deliveryAddressIncludedInFiles
      ) {
        return 'checkOutDeliver'
      } else if (
        this.custom.hideDeliverOptions &&
        this.custom.hideInvoiceOptions &&
        this.checkOutStore.deliveryAddressIncludedInFiles
      ) {
        return 'checkOutCart'
      } else {
        return 'checkOutInvoice'
      }
    },
    errors() {
      return this.checkOutStore.orderErrors
    },
    orderIncomplete() {
      if (this.submitting) {
        return false
      } else if (!this.fileList.length && !this.printStoreProducts.length) {
        return true
      } else if (
        this.fileList.length &&
        !this.fileList.every((prod) => {
          return prod.productSpecs.hasOwnProperty('title')
        })
      ) {
        return true
      } else if (this.errors.length > 0) {
        return true
      } else {
        return false
      }
    },
    combiOrder() {
      return (
        this.printStoreStore.orderDetails.cart.length > 0 &&
        this.fileListStore.fileList.length > 0
      )
    },
    printStoreOnly() {
      return (
        this.printStoreStore.orderDetails.cart.length > 0 &&
        this.fileListStore.fileList.length === 0
      )
    },
    showPrintStoreAd() {
      return (
        this.rootStore.interactions.some(
          (ia) => ia.destination === 'printStore'
        ) && !this.custom.printStoreAd.hideAds
      )
    },
    orderPrice() {
      let totalPrice = 0
      this.fileList.forEach((file) => {
        if (
          file.price &&
          file.price !== 'NA' &&
          !file.productSpecs?.hidePrice
        ) {
          // For mailing orders, use only the unit price (not price * quantity)
          let rowPrice
          if (file.productSpecs?.priceType === 'mailing') {
            rowPrice = file.price
          } else {
            rowPrice = file.quantity * file.price
          }
          totalPrice += rowPrice
        }
      })

      this.printStoreProducts.forEach((product) => {
        if (product.price) {
          let rowPrice = product.volumeQuantity
            ? parseInt(product.price)
            : product.quantity * product.price

          totalPrice += rowPrice
        }
      })

      totalPrice = totalPrice.toFixed(2).replace('.', ',')
      return '€ ' + totalPrice
    },
    priceError() {
      if (
        this.fileList.some((file) => {
          return file.status === 'READY_NOT_ANALYZED'
        })
      ) {
        return true
      } else {
        return false
      }
    },
    fileList() {
      return this.checkOutStore.products
    },
    showPrice() {
      if (!this.custom.productOrder?.calculatePrice) {
        return false
      }
      // Hide price if all files have hidePrice
      const allHidePrice =
        this.fileList.length > 0 &&
        this.fileList.every((file) => file.productSpecs?.hidePrice)
      return !allHidePrice
    },
    phoneRequired() {
      return this.custom.checkOut?.phoneRequired
    },
    user() {
      return this.rootStore.user
    }
  }
}
</script>

<style lang="scss" scoped>
/* .error-text {
  font-weight: 600;
} */
.order-step {
  padding-bottom: 50px;
}

.confirm-card .phone-holder {
  padding-bottom: 10px;
}

.card-header {
  // padding: 30px 30px 0;
  font-weight: 600;
}

.file-list {
  .title-container {
    padding: 30px 30px 0;
  }

  .phone-holder {
    padding: 20px 30px;
  }
}

.print-file-list {
  padding: 10px 30px;
}

.printstore-title {
  font-weight: 600;
  padding-bottom: 15px;
  padding-left: 15px;
}

.confirm {
  background-color: var(--arch-color);
  color: var(--arch-text-color);

  &.icon :deep(g) {
    fill: var(--arch-text-color);
  }

  &:disabled {
    opacity: 1;
    background: #f9f9f9;
    color: #a7a7a7;
    :deep(g) {
      fill: #a7a7a7;
    }
  }
}

.totalprice {
  text-align: right;
  padding: 0 55px 20px;

  span {
    font-weight: 600;
    padding-left: 7px;
  }

  .price {
    font-weight: 300;
  }
}

.instruction-text {
  width: 100%;
  margin-top: 10px;
  height: 130px;
}
</style>
